import type { DocumentTemplateEntityType, DocumentType } from 'types/graphql';

export type DocumentOptions = { type: DocumentType; entity: DocumentTemplateEntityType; label?: string };

export type GenerationOptions = { productDescriptionTemplate?: string };

export const documentTypeOptions: DocumentOptions[] = [
  { entity: 'SALES_ORDER', type: 'SALES_ORDER_CONFIRMATION', label: 'Sales Order Confirmation' },
  { entity: 'SALES_ORDER', type: 'CUSTOM', label: 'Custom Template' },
  { entity: 'SALES_ORDER', type: 'CARRIER_CONFIRMATION', label: 'Carrier Confirmation' },
  { entity: 'SALES_ORDER', type: 'PICK_TICKET', label: 'Pick Ticket' },
  { entity: 'SALES_ORDER', type: 'BILL_OF_LADING', label: 'Bill of Lading' },
  { entity: 'SALES_ORDER', type: 'PASSING', label: 'Passing' },
  { entity: 'SALES_ORDER', type: 'SHIPMENT_CONFIRMATION', label: 'Shipment Confirmation' },
  { entity: 'PURCHASE_ORDER', type: 'PURCHASE_ORDER_CONFIRMATION', label: 'Purchase Order Confirmation' },
  { entity: 'PURCHASE_ORDER', type: 'CUSTOM', label: 'Custom Template' },
  { entity: 'PURCHASE_ORDER', type: 'CARRIER_CONFIRMATION', label: 'Carrier Confirmation' },
  { entity: 'PURCHASE_ORDER', type: 'RECEIVING_TICKET', label: 'Receiving Ticket' },
  { entity: 'BUY_SELL_ORDER', type: 'CUSTOM', label: 'Custom Template' },
  { entity: 'BUY_SELL_ORDER', type: 'BILL_OF_LADING', label: 'Bill of Lading' },
  { entity: 'BUY_SELL_ORDER', type: 'CARRIER_CONFIRMATION', label: 'Carrier Confirmation' },
  { entity: 'BUY_SELL_ORDER', type: 'SALES_ORDER_CONFIRMATION', label: 'Sales Order Confirmation' },
  { entity: 'BUY_SELL_ORDER', type: 'PURCHASE_ORDER_CONFIRMATION', label: 'Purchase Order Confirmation' },
  { entity: 'BUY_SELL_ORDER', type: 'PASSING', label: 'Passing' },
  { entity: 'INVOICE', type: 'INVOICE', label: 'Invoice' },
  { entity: 'INVOICE', type: 'CUSTOM', label: 'Custom Invoice' },
  { entity: 'GROWER_SETTLEMENT', type: 'GROWER_SETTLEMENT', label: 'Grower Settlement' },
  { entity: 'GROWER_SETTLEMENT', type: 'CUSTOM', label: 'Custom Settlement' },
  { entity: 'REMITTANCE', type: 'REMITTANCE', label: 'Remittance' },
  { entity: 'CUSTOMER_STATEMENT', type: 'OTHER', label: 'Customer Statement' },
  { entity: 'GROWER_PRODUCT', type: 'WORK_ORDER_CONFIRMATION', label: 'Grower Product' },
  { entity: 'GROWER_PRODUCT', type: 'RECEIVING_TICKET', label: 'Receiving Ticket' },
  { entity: 'GROWER_PRODUCT', type: 'BILL_OF_LADING', label: 'Bill of Lading' },
  { entity: 'PRODUCTION_RUN', type: 'PRODUCTION_RUN_REPORT', label: 'Production Run Report' },
  { entity: 'INVENTORY_TRANSFER', type: 'BILL_OF_LADING', label: 'Bill of Lading' },
  { entity: 'BALANCE_SHEET_REPORT', type: 'OTHER', label: 'Balance Sheet Report' },
  { entity: 'PROFIT_AND_LOSS_REPORT', type: 'OTHER', label: 'Profit and Loss Report' },
];

export const documentVariables: Record<DocumentTemplateEntityType, { variable: string; type: 'number' | 'string' }[]> =
  {
    SALES_ORDER: [{ variable: 'slug', type: 'string' }],
    PURCHASE_ORDER: [{ variable: 'slug', type: 'string' }],
    BUY_SELL_ORDER: [{ variable: 'slug', type: 'string' }],
    GROWER_PRODUCT: [{ variable: 'slug', type: 'string' }],
    PRODUCTION_RUN: [{ variable: 'slug', type: 'string' }],
    INVOICE: [{ variable: 'slug', type: 'string' }],
    GROWER_SETTLEMENT: [{ variable: 'slug', type: 'string' }],
    REMITTANCE: [{ variable: 'slug', type: 'string' }],
    CUSTOMER_STATEMENT: [{ variable: 'businessEntityId', type: 'number' }],
    INVENTORY_TRANSFER: [{ variable: 'slug', type: 'string' }],
    BALANCE_SHEET_REPORT: [],
    PROFIT_AND_LOSS_REPORT: [],
  };

export const documentTypeGroups: Record<DocumentTemplateEntityType, string> = {
  SALES_ORDER: 'Sales Order',
  PURCHASE_ORDER: 'Purchase Order',
  BUY_SELL_ORDER: 'Buy-Sell Order',
  GROWER_PRODUCT: 'Grower Product',
  PRODUCTION_RUN: 'Production Run',
  INVOICE: 'Invoice',
  GROWER_SETTLEMENT: 'Grower Settlement',
  REMITTANCE: 'Remittance',
  CUSTOMER_STATEMENT: 'Customer Statement',
  INVENTORY_TRANSFER: 'Inventory Transfer',
  BALANCE_SHEET_REPORT: 'Balance Sheet Report',
  PROFIT_AND_LOSS_REPORT: 'Profit and Loss Report',
};
